import React from "react";
import { titles } from "constants/titles";
import { SubscriberDetailIcon, IconQuestion } from "assets/SVGs/SVGs";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { formatDate, formatPhoneNumber, getSubscriberProtectedAddress } from "utility";

const SubscriberDetailsCard = ({
  medicalUserDetail,
  protected_address,
  onEditSubscriberDetail,
  onEmergencyInfoModal,
  showEditButton = true
}) => {
  return (
    <div className="sp_subscriber_details_card">
      <div className="sp_card_header">
        <h3 className="sp_card_title">{titles?.subscriber_details}</h3>
        <div className="sp_card_icon">
          <SubscriberDetailIcon />
        </div>
      </div>
      <div className="sp_separator"></div>
      <div className="sp_details_content">
        {medicalUserDetail?.date_of_birth ? (
          <div className="sp_detail_row">
            <span className="sp_detail_label">{titles?.date_of_birth}:</span>
            <span className="sp_detail_value">
              {formatDate(medicalUserDetail?.date_of_birth)}
            </span>
          </div>
        ) : null}
        {protected_address?.mobile ? (
          <div className="sp_detail_row">
            <span className="sp_detail_label">{titles?.home_phone}:</span>
            <span className="sp_detail_value">
              {formatPhoneNumber(protected_address?.mobile)}
            </span>
          </div>
        ) : null}
        {protected_address?.cellphone ? (
          <div className="sp_detail_row">
            <span className="sp_detail_label">{titles?.cell_phone}:</span>
            <span className="sp_detail_value">
              {formatPhoneNumber(protected_address?.cellphone)}
            </span>
          </div>
        ) : null}
        <div className="sp_protected_address_section">
          <div className="sp_protected_address_header">
            <div className="sp_protected_address_content">
              <span className="sp_protected_address_label">
                {titles?.protected_address}
              </span>
              <p className="sp_protected_address_text">
                {getSubscriberProtectedAddress(protected_address)}
              </p>
            </div>
            {onEmergencyInfoModal && <IconQuestion
              width={24}
              height={24}
              onClick={onEmergencyInfoModal}
              className="sp_question_icon"
            />}
          </div>
        </div>
      </div>
      {showEditButton && (
        <CustomButton
          text={titles?.edit_subscriber_details}
          width="100%"
          className={'sp_button_top_margin'}
          onClick={onEditSubscriberDetail}
        />
      )}
    </div>
  );
};

export default SubscriberDetailsCard;
